import { render, staticRenderFns } from "./AdminPrivateOrder.vue?vue&type=template&id=722638dc&"
import script from "./AdminPrivateOrder.vue?vue&type=script&lang=js&"
export * from "./AdminPrivateOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports